module.exports = __webpack_public_path__ + "static/test-1-ae61effae907929bba76099ab609040f.jpg";